<template>
  <div class="content">
    <van-nav-bar @click-left="onClickLeft" :title="ar_info.title" @click-right="onClickRight">
      <template #left>
        <img style="width: 2.66667vw;height: 5.33333vw;display: inline-block;" :src="require('../../assets/'+appTheme+'/right_icon2.png')" alt="">
      </template>
      <template #right>
        <img style="width: 4.93333vw;height: auto;display: inline-block;" :src="require('../../assets/'+appTheme+'/car_icon.png')" alt="">
      </template>
    </van-nav-bar>
    <!--  <div class="title">{{ar_info.title}}</div>-->
    <div class="des-box" id="des-box">
      <div class="div-desc" v-html="ar_info.content"> {{ar_info.content}}</div>
    </div>
  </div>
</template>

<script>
import {articleDes} from "@/api/xieyi";

export default {
name: "xieYiDes",
  data(){
    return{
      appTheme:this.$store.state.appTheme,
      a_id: '',
      ar_info: ''
    }
  },
  created() {
    this.a_id = this.$route.query.id
    this.getDes()
  },
  methods: {
    onClickLeft() {
      if (window.history.length <= 1) {
        this.$router.push('/');
        return false
      } else {
        this.$router.go(-1);
      }
    },
    onClickRight() {
      this.$router.push({path:'/cart'})
    },
    getDes(){
      var that =this
      articleDes(this.a_id).then(res => {
        if(res.code == 200)
        {
          // console.log('res',res.data)
          that.ar_info = res.data

        }
        else
        {
          this.$toast(res.message)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.van-nav-bar {
  background: #FDD80D;color: #333333;font-weight: bold;font-size: 30px;
}
.van-nav-bar .van-icon {
  color: #333333;
}
.div-desc{
  padding: 20px;
}
.title{
  font-weight: bold;text-align: center;font-size: 32px;padding: 30px 20px;
}
.content{
  background: #fff;
}
</style>
